import type { NavigationGuard } from 'vue-router';
import { session } from '@/helpers/auth';
import { getTokenExpirationTimestamp } from '@/shared/common/utils/token.util';
import { getMcpAuthorizationQuery } from '@/shared/mcpAuthorization/utils/mcpAuthorizationParams.util';

/**
 * Falla ABIERTO cuando no hay expiración registrada: sin ese dato no podemos
 * afirmar que el token venció, y el backend sigue siendo la autoridad. Solo se
 * rechaza lo que se puede probar vencido.
 *
 * @returns `true` si hay token y no consta que haya expirado.
 */
function hasValidSession(): boolean {
  if (!session()) return false;

  const expiresAt = getTokenExpirationTimestamp();
  return expiresAt === null || expiresAt > Date.now();
}

/**
 * Exige sesión vigente antes de dejar entrar a `/oauth/authorize`: la página
 * golpea `mcpOauthService.getConsentId` apenas se monta, y con un token vencido
 * ese 401 dispara `logOut()`, que redirige al login **sin** los params OAuth y
 * deja al usuario en el home sin forma de retomar la autorización.
 *
 * @param to - Ruta de destino, de donde salen los params OAuth a preservar.
 * @returns `true` para continuar, o la ubicación de login con los params.
 */
export const validateMcpAuthorization: NavigationGuard = (to) => {
  if (hasValidSession()) return true;

  return { name: 'log-in', query: getMcpAuthorizationQuery(to.query) };
};
